import { Divider, Typography } from "@mui/material";
import { prettyDate, prettyDateDay } from "@utils/metrics/timeFunction";
import Image from "next/legacy/image";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import theme from "src/globalModule/styles/theme";
import classes from "../../styles/pujaMainCard.module.css";
import { useTranslation } from "react-i18next";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { useCookies } from "react-cookie";
import { useRouter } from "next/router";
function PujaBookingDetailsCard({
  subEventDetails,
  show = true,
  receipt,
  cardBox = false
}) {
  const page = useSelector(state => state.pujaBooking)?.page;
  const [cookies, setCookie, removeCookie] = useCookies(["seatNo"]);
  const [seatNo, setSeatNo] = useState(0);
  const {
    cart,
    pujaAmount,
    totalAmount,
    totalItems
  } = useSelector(state => state.cart);
  const {
    t
  } = useTranslation();
  const router = useRouter();
  const [images, setImages] = useState([]);
  const [eventName, setEventName] = useState("");
  const [name, setName] = useState("");
  const [festivalName, setFestivalName] = useState("");
  const [amount, setAmount] = useState("");
  const [bhetAmount, setBhetAmount] = useState("");
  const [prasadAmount, setPrasadAmount] = useState("");
  const [totalPrice, setTotalPrice] = useState("");
  const [pujaDate, setPujaDate] = useState("");
  const [bhetItems, setBhetItems] = useState([]);
  const [prasadItems, setPrasadItems] = useState([]);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  useEffect(() => {
    if (subEventDetails) {
      setImages(subEventDetails?.images || []);
      setEventName(subEventDetails?.eventName);
      setName(subEventDetails?.name);
      setFestivalName(subEventDetails?.festivalName);
      setPujaDate(subEventDetails?.start);
    }
    if (cookies.seatNo && parseInt(cookies.seatNo) > 0) {
      setSeatNo(parseInt(cookies.seatNo, 10));
    }
  }, [subEventDetails]);
  useEffect(() => {
    if (page == 1 || page == 2) {
      setAmount(subEventDetails?.eventRegistrationAmount);
    } else if (page == 3) {
      setAmount(pujaAmount);
      // setBhetAmount(totalAmount > pujaAmount ? totalAmount - pujaAmount : 0);
      setTotalPrice(totalAmount === 0 ? pujaAmount : totalAmount);
      // setBhetItems(totalItems);
      const bhetItem = cart.filter(item => item.isMainPrasad === false);
      const prasadItem = cart.filter(item => item.isMainPrasad === true);
      if (bhetItem.length > 0) {
        setBhetItems(bhetItem.length);
        setBhetAmount(bhetItem.reduce((acc, item) => acc + Number(item.eventRegistrationAmount), 0));
      }
      if (prasadItem.length > 0) {
        setPrasadItems(prasadItem.length);
        setPrasadAmount(prasadItem.reduce((acc, item) => acc + Number(item.eventRegistrationAmount), 0));
      }
    }
    setCurrentPageNo(page);
  }, [page, cart]);
  return <div className={classes.containerRHS} data-sentry-component="PujaBookingDetailsCard" data-sentry-source-file="pujaBookingDetailsCard.jsx">
      <div className={receipt ? classes.pujaDetailsReceipt : cardBox ? classes.pujaDetailsCardBox : classes.pujaDetails}>
        {images.length > 0 && <Image src={images[0] || ""} alt="Sub Event Image" width={80} height={80} objectFit="cover" className={classes.pujaImageItem} />}

        <div className={classes.pujaDetailsCard}>
          <Typography sx={{
          fontSize: "16px",
          fontWeight: "600"
        }} className={classes.ellipsisHeader} data-sentry-element="Typography" data-sentry-source-file="pujaBookingDetailsCard.jsx">
            {eventName}
          </Typography>
          <Typography sx={{
          fontSize: "15px"
        }} className={classes.ellipsisText} data-sentry-element="Typography" data-sentry-source-file="pujaBookingDetailsCard.jsx">
            {name}
          </Typography>
          {currentPageNo === 1 && !receipt && seatNo > 0 ? <div className={classes.remainingSeatsContainer}>
              <Typography className={classes.remainingSeats}>
                {t("only")} {seatNo} {t("seats-in-this-slot")}
              </Typography>
            </div> : <div className={classes.dateContainer}>
              <CalendarMonthIcon sx={{
            fontSize: "14px"
          }} />
              <Typography sx={{
            fontSize: "14px",
            color: theme.palette.text.primaryHead
          }}>
                {prettyDateDay(new Date(parseInt(pujaDate)), router.locale)}
              </Typography>
            </div>}
        </div>
      </div>

      {show && <div className={classes.pujaBookReviewSection}>
          {/* <Divider sx={{ opacity: "0.5", borderStyle: "dashed" }} /> */}
          <div className={classes.pujaBookReviewSectionRow}>
            <Typography sx={{
          fontSize: "15px",
          color: theme.palette.text.secondaryDark
        }}>
              {t("puja-date")}
            </Typography>
            <Typography sx={{
          fontSize: "15px",
          color: theme.palette.text.primaryHead,
          fontWeight: "bold"
        }}>
              {prettyDate(new Date(parseInt(pujaDate)), router.locale)}
            </Typography>
          </div>
          <Divider sx={{
        opacity: "0.5",
        borderStyle: "dashed"
      }} />
          {festivalName && <>
              <div className={classes.pujaBookReviewSectionRow}>
                <Typography sx={{
            fontSize: "15px",
            color: theme.palette.text.secondaryDark
          }}>
                  {t("puja-tithi")}{" "}
                </Typography>
                <Typography sx={{
            fontSize: "15px",
            color: theme.palette.text.primaryHead,
            fontWeight: "bold"
          }}>
                  {festivalName}
                </Typography>
              </div>
              <Divider sx={{
          opacity: "0.5",
          borderStyle: "dashed"
        }} />
            </>}
          {page != 4 && <div className={classes.pujaBookReviewSectionRow}>
              <Typography sx={{
          fontSize: "15px",
          color: theme.palette.text.secondaryDark
        }}>
                {t("puja-dakshina")}
              </Typography>
              <Typography sx={{
          fontSize: "15px",
          color: theme.palette.text.primaryHead,
          fontWeight: "bold"
        }}>
                ₹ {amount}/-
              </Typography>
            </div>}
          {page == 3 && <>
              <Divider sx={{
          opacity: "0.5",
          borderStyle: "dashed"
        }} />
              {bhetItems > 0 && <>
                  <div className={classes.pujaBookReviewSectionRow}>
                    <Typography sx={{
              fontSize: "15px",
              color: theme.palette.text.secondaryDark
            }}>
                      {t("bhet")} x {bhetItems}
                    </Typography>
                    <Typography sx={{
              fontSize: "15px",
              color: theme.palette.text.primaryHead,
              fontWeight: "bold"
            }}>
                      ₹ {bhetAmount}/-
                    </Typography>
                  </div>
                  <Divider sx={{
            opacity: "0.5",
            borderStyle: "dashed"
          }} />
                </>}
              {prasadItems > 0 && <>
                  <div className={classes.pujaBookReviewSectionRow}>
                    <Typography sx={{
              fontSize: "15px",
              color: theme.palette.text.secondaryDark
            }}>
                      {"Prasad"} x {prasadItems}
                    </Typography>
                    <Typography sx={{
              fontSize: "15px",
              color: theme.palette.text.primaryHead,
              fontWeight: "bold"
            }}>
                      ₹ {prasadAmount}/-
                    </Typography>
                  </div>
                  <Divider sx={{
            opacity: "0.5",
            borderStyle: "dashed"
          }} />
                </>}
              <div className={classes.pujaBookReviewSectionRow}>
                <Typography sx={{
            fontSize: "15px",
            color: theme.palette.text.secondaryDark
          }}>
                  {t("total-dakshina")}
                </Typography>
                <Typography sx={{
            fontSize: "15px",
            color: theme.palette.text.primaryHead,
            fontWeight: "bold"
          }}>
                  ₹ {totalPrice}/-
                </Typography>
              </div>
            </>}
        </div>}

      {/* <Divider sx={{ opacity: 0.5 }} /> */}
    </div>;
}
export default PujaBookingDetailsCard;